import React from 'react'

type RecipePreferenceStepProps = {
  next: () => void
}

export const RecipePreferenceStep = ({ next: _next }: RecipePreferenceStepProps) => (
  <>PlaceHolder/TG-8631</>
)
